import React from 'react';
import { ListModeDemo } from '@/components/data-mapping-list-mode';
import { Layout, Typography } from 'antd';

const { Content } = Layout;
const { Title } = Typography;

const MockDemoPage = () => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Content style={{ padding: '24px', backgroundColor: '#f5f5f5' }}>
        <Title level={2} style={{ marginBottom: '24px' }}>Data Mapping List Mode Demo</Title>
        <ListModeDemo />
      </Content>
    </Layout>
  );
};

export default MockDemoPage; 